// extracted by css-extract-rspack-plugin
export default {"cls1":"PreprintExportStep-cls1_4zD","cls2":"PreprintExportStep-cls2_0ne PreprintExportStep-cls1_4zD"};